import { createGlobalStyle } from 'styled-components';
import { setColor, setRem } from './utils/styles';

const GlobalStyles = createGlobalStyle`
  *,
  *::before, 
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
  }

  body {
    font-family: Rubik, sans-serif;
    overflow: hidden;
  }

  html, body {
    height: 100%;
  }

  #react-root {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }

  h1 {
    font-size: ${setRem(32)};
    font-weight: 700;
    color: ${setColor.primaryColor};
  }

  h2 {
    font-size: ${setRem(20)};
    margin-bottom: ${setRem(24)};
    color: ${setColor.primaryColor};
  }

  strong {
    font-weight: 700;
    color: ${setColor.primaryColor};
  }

  p {
    line-height: 1.38;
  }

  a {
    text-decoration: none;
    color: ${setColor.primaryColor};
  }
`;

export default GlobalStyles;
